import { Group, Stack } from '@mantine/core';
import React from 'react';
import StyledInputLabel from '@/components/StyledInputFields/StyledInputLabel.tsx';
import StyledSwitch from '@/components/StyledInputFields/StyledSwitch.tsx';
import StyledTextarea from '@/components/StyledInputFields/StyledTextarea.tsx';
import StyledNumberInput from '@/components/StyledInputFields/StyledNumberInput.tsx';
import { STEP_LOGIC_MAX_LENGTH } from '@/utils/constants.ts';
import { ExtractDataStep } from '@/types/automationSteps.ts';
import { useUpdateStepFields } from '@/hooks/api/steps/useUpdateStepFields.ts';

type Props = {
  step: ExtractDataStep;
};

type Fields = {
  verify_extracted_data: boolean;
  verification_instructions: string;
  max_verification_repair_attempts: number;
};

const ExtractVerificationFields = ({ step }: Props) => {
  const { fields, onChange } = useUpdateStepFields<Fields>({ step });

  return (
    <Stack w="100%" gap="sm">
      <Group justify="space-between" align="center">
        <StyledInputLabel size="sm" capabilityFieldId="verify_extracted_data">
          Verify extracted data
        </StyledInputLabel>
        <StyledSwitch
          checked={fields.verify_extracted_data}
          onChange={(event) => onChange({ verify_extracted_data: event.target.checked })}
        />
      </Group>

      {fields.verify_extracted_data && (
        <>
          <StyledTextarea
            label="Final verification instructions"
            capabilityFieldId="verification_instructions"
            value={fields.verification_instructions}
            description="Applies only to the post-extraction table verification pass; it does not control normal field or entity review."
            placeholder="Check extracted values for consistency across entities before publishing output."
            onChange={(event) =>
              onChange({ verification_instructions: event.currentTarget.value })
            }
            maxLength={STEP_LOGIC_MAX_LENGTH}
            autosize
            minRows={2}
          />
          <StyledNumberInput
            label="Automatic repair attempts"
            capabilityFieldId="max_verification_repair_attempts"
            value={fields.max_verification_repair_attempts}
            min={0}
            max={2}
            step={1}
            onChange={(value) =>
              onChange({
                max_verification_repair_attempts: typeof value === 'number' ? value : 1,
              })
            }
          />
        </>
      )}
    </Stack>
  );
};

export default ExtractVerificationFields;
